import ProductModelBase from '../_generated/modelBases/product-model-base';

export default class ProductModel extends ProductModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
